<div class="modal-header">
  <h2 class="modal-header__title">
    Choose File Language
  </h2>
</div>

<mat-dialog-content>
  <p-dropdown
    class="w-100"
    [options]="languages"
    [ngModel]="languageCode()"
    (ngModelChange)="languageCode.set($event)"
    placeholder="Select a Language"
    optionLabel="label"
    optionValue="value"
    [showClear]="true"
    appendTo="body"
  ></p-dropdown>
</mat-dialog-content>

<mat-dialog-actions class="justify-content-between">
  <button
    pButton
    type="button"
    label="Cancel Download"
    [mat-dialog-close]="false"
  >
  </button>
  <button
    pButton
    type="button"
    class="p-button-success"
    label="Continue"
    [disabled]="!languageCode()"
    [mat-dialog-close]="languageCode()"
  >
  </button>
</mat-dialog-actions>
